import { render, staticRenderFns } from "./VersionEditionSelection.vue?vue&type=template&id=325c764e&scoped=true"
import script from "./VersionEditionSelection.vue?vue&type=script&lang=js"
export * from "./VersionEditionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c764e",
  null
  
)

export default component.exports